import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useDesignVersion } from "../DesignVersionContext";
import HeaderV2 from "./HeaderV2";
import style from "../style/components/Header.module.css";

const Header = () => {
    const { version } = useDesignVersion();
    const [openMenu, setOpenMenu] = useState<boolean>(false);

    useEffect(() => {
        document.body.style.overflow = openMenu ? "hidden" : "auto";
    }, [openMenu]);

    if (version === "v2") {
        return <HeaderV2 />;
    }

    return (
        <div className={style["container"]}>
            <button
                className={[style["menu"], openMenu && style["active"]].join(" ")}
                onClick={() => setOpenMenu((prev) => !prev)}
            >
                <span>
                    <span className={style["top"]}></span>
                </span>
                <span>
                    <span className={style["middle"]}></span>
                </span>
                <span>
                    <span className={style["bottom"]}></span>
                </span>
            </button>
            <div className={[style["unit"], openMenu && style["active"]].join(" ")}>
                <RouterButton text="키오스크 관리" router="/" />
                <RouterButton text="계정 관리" router="/admin" />
                <RouterButton text="파트너사 관리" router="/partner" />
                <RouterButton text="공지사항 관리" router="/notice" />
                <RouterButton text="엑셀 출력" router="/excel" />
                <RouterButton text="통계" router="/stats" />
                <RouterButton text="포인트 관리" router="/point" />
            </div>
        </div>
    );
};

const RouterButton = ({ text, router }: { text: string; router: string }) => {
    const [hovered, setHovered] = useState<boolean>(false);
    const [clicked, setClicked] = useState<boolean>(false);

    return (
        <Link to={router}>
            <button
                // hover events
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => {
                    setHovered(false);
                    setClicked(false);
                }}
                // click events
                onMouseDown={() => setClicked(true)}
                onMouseUp={() => setClicked(false)}
                onTouchStart={() => setClicked(true)}
                onTouchEnd={() => setClicked(false)}
                className={[
                    style["button--router"],
                    hovered && style["button--router--hovered"],
                    clicked && style["button--router--clicked"],
                ].join(" ")}
            >
                {text}
            </button>
        </Link>
    );
};

export default Header;
